//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/AME.js";
import "../no/Builder.js";
let d=[[],[[["objectTypeName","groupName","propertyName"],"Add",{},3,0],[["objectTypeName","groupName","propertyName"],"MoveUp",{},3,0],[["objectTypeName","groupName","propertyName"],"Remove",{},3,0],[["objectTypeName","groupName","propertyName"],"MoveDown",{},3,0],[["objectTypeName","groupName","propertyName","visibility"],"SetVisibility",{},4,0],[["objectType","categoryType","propertyName","sortType"],"AddSortingCriteria",{},4,0],[[],"ClearSortingCriteria",{},0,0]],[]];
SPLM.AME.ConfigureResultTableBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.AME.ConfigureResultTableBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;